import { DocumentReference, getFirestore } from 'firebase/firestore';
import { FirebaseError } from 'firebase/app';
import { collection, doc, onSnapshot, setDoc, getDoc } from 'firebase/firestore';
import { arrayUnion, arrayRemove, updateDoc } from 'firebase/firestore';
import { app } from 'src/firebase';
import * as Sentry from '@sentry/react';

const db = getFirestore(app);

const sendExceptionToSentry = (error: unknown, userId: string) => {
  Sentry.withScope((scope) => {
    scope.setTag('module', 'firestore.util');
    scope.setExtra('userId', userId);
    Sentry.captureException(error);
  });
};

export async function subscribe(userId: string, fn: { (value: string[]): void }) {
  const userRef = await findOrCreateUserRef(userId);
  console.log('subscribed');
  return onSnapshot(userRef, (doc) => {
    console.log('Current data: ', doc.data());
    fn(doc.data()?.favorites ?? []);
  });
}

export async function addUserFavorite(userId: string, tripId: string) {
  const userRef = await findOrCreateUserRef(userId);
  try {
    await updateDoc(userRef, {
      favorites: arrayUnion(tripId),
    });
  } catch (error) {
    sendExceptionToSentry(error, userId);
    if (error instanceof FirebaseError) {
      console.error(`Firebase error: ${error.message}`);
    } else {
      console.error(`Unknown error: ${error}`);
    }
  }
}

export async function removeUserFavorite(userId: string, tripId: string) {
  const userRef = await findOrCreateUserRef(userId);
  try {
    await updateDoc(userRef, {
      favorites: arrayRemove(tripId),
    });
  } catch (error) {
    sendExceptionToSentry(error, userId);
    if (error instanceof FirebaseError) {
      console.error(`Firebase error: ${error.message}`);
    } else {
      console.error(`Unknown error: ${error}`);
    }
  }
}

export async function mergeUserFavorites(userId: string, tripIds: string[]) {
  const userRef = await findOrCreateUserRef(userId);
  try {
    await updateDoc(userRef, {
      favorites: arrayUnion(...tripIds),
    });
  } catch (error) {
    sendExceptionToSentry(error, userId);
    if (error instanceof FirebaseError) {
      console.error(`Firebase error: ${error.message}`);
    } else {
      console.error(`Unknown error: ${error}`);
    }
  }
}

export async function findOrCreateUserRef(userId: string): Promise<DocumentReference> {
  const userRef = doc(collection(db, 'websiteUserInformation'), userId);
  const docSnap = await getDoc(userRef);
  const user = {
    favorites: [],
  };

  if (!docSnap.exists()) {
    try {
      await setDoc(userRef, user);
    } catch (error) {
      sendExceptionToSentry(error, userId);
      if (error instanceof FirebaseError) {
        console.error(`Firebase error: ${error.message}`);
      } else {
        console.error(`Unknown error: ${error}`);
      }
      throw error;
    }
  } else {
    console.log('User already exists in Firestore');
  }
  return userRef;
}
